import { Grid, Box, Tooltip, Button, Chip } from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import { useDropzone } from "react-dropzone";
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const LogoUploader = ({
  formData,
  imagePreview,
  setImagePreview,
  setBase64Image,
  isEditingLogo,
  setIsEditingLogo,
  handleSave,
  setCropDialog,
}) => {
  const onDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setCropDialog({
          open: true,
          imageSrc: base64,
          crop: { unit: "px", width: 150, aspect: 2 / 3 },
        });
        setIsEditingLogo(true);
      };
      reader.readAsDataURL(acceptedFiles[0]);
    }
  };

  const {
    getRootProps,
    getInputProps,
    open: triggerFileInput,
  } = useDropzone({
    accept: "image/*",
    onDrop,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <Box
      sx={{
        borderRadius: "8px",
        marginTop: "20px",
        padding: "20px",
        backgroundColor: "var(--bg-paper)",
        width: "99%",
        position: "relative",
        borderBottom: "0.5px solid var(--border-color)",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          style={{
            minWidth: "40%",
            justifyContent: "start",
            display: "flex",
            flexDirection: "row",
          }}
          item
        >
          <CustomTypography
            color={"#33333"}
            style={{ fontWeight: "500", height: 20 }}
            variant="body1"
          >
            Logo
          </CustomTypography>
        </Grid>

        <Grid item>
          <div {...getRootProps()} style={{ position: "relative" }}>
            {imagePreview || formData.logo ? (
              <Tooltip title="Update your logo">
                <>
                  <img
                    src={imagePreview || formData.logo}
                    alt="Logo"
                    style={{
                      width: "150px",
                      height: "80px",
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      triggerFileInput();
                    }}
                  />
                </>
              </Tooltip>
            ) : (
              <Box
                onClick={() => {
                  triggerFileInput();
                }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <img
                  style={{ height: 40, width: 40, marginRight: 10 }}
                  src="./upload.png"
                  alt="plus"
                />
                <CustomTypography
                  style={{
                    fontWeight: "500",
                    color: "#979797",
                    textDecoration: "underline",
                  }}
                >
                  Add your logo
                </CustomTypography>
              </Box>
            )}
            <input {...getInputProps()} />
          </div>
        </Grid>

        {isEditingLogo && imagePreview && (
          <Box
            sx={{
              margin: 2,
              width: "95%",
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <Button
              style={{ marginRight: 15, color: "red", borderColor: "red" }}
              variant="outlined"
              onClick={() => {
                setIsEditingLogo(false);
                setImagePreview(null);
                setBase64Image("");
              }}
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSave}>
              Update
            </Button>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default LogoUploader;
